import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=3dc812f9&scoped=true&"
import script from "./verification.vue?vue&type=script&lang=js&"
export * from "./verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc812f9",
  null
  
)

export default component.exports